import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import axios from "../../libs/axios";

import Drawer from "@mui/material/Drawer";
import { Button } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";
import { useLocation } from "react-router-dom";

// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";

export default function TemporaryDrawer({
  page,
  getPage,
  formData,
  setCallingBackend,
}) {
  const [open, setOpen] = React.useState(false);
  
  const [filteredSteps, setFilteredSteps] = useState([])
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const { state } = useLocation();

  // eslint-disable-next-line
  const [pageNum, setPageNum] = useState(page);

  const steps = [
    { formNo: 1, name: "Aditional Assessment Details" },
    { formNo: 2, name: "Operational Overview" },
    { formNo: 3, name: "Construction" },
    { formNo: 4, name: "Overall Construction Classification" },
    { formNo: 5, name: "Construction RI" },
    { formNo: 6, name: "Occupancy" },
    { formNo: 7, name: "Fire Area" },
    { formNo: 8, name: "Special Hazards" },
    { formNo: 9, name: "Special Hazards RI" },
    { formNo: 10, name: "Essential Services" },
    { formNo: 11, name: "Sprinkler Systems" },
    { formNo: 12, name: "Sprinkler System Demands" },
    { formNo: 13, name: "Hydrant Systems" },
    { formNo: 14, name: "Towns Main Water Supply" },
    { formNo: 15, name: "Pump 1 Water Supply" },
    { formNo: 16, name: "Pump 2 Water Supply" },
    { formNo: 17, name: "Pump 3 Water Supply" },
    { formNo: 18, name: "Pump 4 Water Supply" },
    { formNo: 19, name: "Water Supply Reliability" },
    { formNo: 20, name: "Fire Detection" },
    { formNo: 21, name: "Other Fire Response" },
    { formNo: 22, name: "Asset Protection" },
    { formNo: 23, name: "Asset Protection RI" },
    { formNo: 24, name: "Management Practices" },
    { formNo: 25, name: "Management Practices RI" },
    { formNo: 26, name: "Natural Hazards Exposures" },
    { formNo: 27, name: "Natural Hazards Magnitude" },
    { formNo: 28, name: "Natural Hazards RI" },
    { formNo: 29, name: "External Exposures" },
    { formNo: 30, name: "Site Security" },
    { formNo: 31, name: "Site Photographs" },
    { formNo: 32, name: "Declared Values" },
    { formNo: 33, name: "Sub Limits of Liability" },
    { formNo: 34, name: "Maximum Foreseable Loss (MFL)" },
    { formNo: 35, name: "Normal Loss Expectancy (NLE)" },
    { formNo: 36, name: "WLE Sub Limits of Liability" },
    { formNo: 37, name: "Windstorm Loss Expectancy (WLE)" },
    { formNo: 38, name: "Additional Risk Improvements" },
    { formNo: 39, name: "Risk Improvement Priority" },
    { formNo: 40, name: "Executive Summary" },
    { formNo: 41, name: "ANZSIC Classifications" },
    { formNo: 42, name: "Custom Front and Back Page" },
    { formNo: 43, name: "PDF" },
    { formNo: 44, name: "Data" },
  ];

  const handlePageNumber = async (fNo) => {
    try {
      setCallingBackend(true);
      await axios.put(`/assesment/previous/${state.id}`, {
        form_number: fNo,
      });
      setTimeout(() => getPage(), 1000);
    } catch (error) {
    } finally {
      setCallingBackend(false);
    }
  };
  useEffect(() => {
    const fillter =
      formData?.assessment?.wle_exclude &&
      formData?.assessment?.water_supply_exclude &&
      formData?.assessment?.hysrant_water_supply_exclude
        ? steps.filter(
            (step) =>
              step.formNo !== 19 && step.formNo !== 36 && step.formNo !== 37
          )
        : formData?.assessment?.wle_exclude &&
          !formData?.assessment?.water_supply_exclude &&
          !formData?.assessment?.hysrant_water_supply_exclude
        ? steps.filter((step) => step.formNo !== 36 && step.formNo !== 37)
        : formData?.assessment?.wle_exclude &&
          !formData?.assessment?.water_supply_exclude &&
          formData?.assessment?.hysrant_water_supply_exclude
        ? steps.filter((step) => step.formNo !== 36 && step.formNo !== 37)
        : formData?.assessment?.wle_exclude &&
          formData?.assessment?.water_supply_exclude &&
          !formData?.assessment?.hysrant_water_supply_exclude
        ? steps.filter((step) => step.formNo !== 36 && step.formNo !== 37)
        : !formData?.assessment?.wle_exclude &&
          formData?.assessment?.water_supply_exclude &&
          formData?.assessment?.hysrant_water_supply_exclude
        ? steps.filter((step) => step.formNo !== 19)
        : !formData?.assessment?.wle_exclude &&
          !formData?.assessment?.water_supply_exclude &&
          formData?.assessment?.hysrant_water_supply_exclude
        ? steps
        : !formData?.assessment?.wle_exclude &&
          formData?.assessment?.water_supply_exclude &&
          !formData?.assessment?.hysrant_water_supply_exclude
        ? steps
        : steps;

    setFilteredSteps(fillter);
  }, [
    formData?.assessment?.wle_exclude,
    formData?.assessment?.water_supply_exclude,
    formData?.assessment?.hysrant_water_supply_exclude,
    setFilteredSteps,
  ]);
  const DrawerList = (
    <Box sx={{ width: 300 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {filteredSteps.map((text, index) => (
          <ListItem key={text.formNo} disablePadding>
            <ListItemButton
              onClick={() => {
                handlePageNumber(text.formNo);
              }}
              style={{
                backgroundColor: text?.formNo === page ? "#eeeeee" : "#ffffff",
              }}
              //drower page dissabled
              // disabled={text?.formNo > page ? true : false}
            >
              <ListItemText primary={text.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Button onClick={toggleDrawer(true)} sx={{ color: "#000" }}>
        <MenuRoundedIcon />
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
